"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api/auth-controller-api"), exports);
__exportStar(require("./api/equipment-controller-api"), exports);
__exportStar(require("./api/event-controller-api"), exports);
__exportStar(require("./api/event-location-controller-api"), exports);
__exportStar(require("./api/event-user-controller-api"), exports);
__exportStar(require("./api/excel-controller-api"), exports);
__exportStar(require("./api/instrument-controller-api"), exports);
__exportStar(require("./api/notification-controller-api"), exports);
__exportStar(require("./api/user-controller-api"), exports);
__exportStar(require("./api/user-invitation-controller-api"), exports);
__exportStar(require("./api/view-model-controller-api"), exports);
